function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M94.1,5.5v59.7H35.7V5.5H94.1 M97.1,2.5H32.7v65.7h64.4V2.5L97.1,2.5z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "75.5,49.4 72.5,49.4 72.5,27.3 50.9,27.3 50.9,24.3 75.5,24.3  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 52.8,
  y: 17.9,
  transform: "matrix(0.7142 0.6999 -0.6999 0.7142 47.7556 -24.8797)",
  width: 3,
  height: 56.2
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M32.5,68.2V95H5V68.2H32.5 M35.5,65.2H2V98h33.5V65.2L35.5,65.2z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M94.1,5.5v76H19.7v-76H94.1 M97.1,2.5H16.7v82h80.3V2.5L97.1,2.5z"
})))));

var SvgPositioningTwo = function SvgPositioningTwo(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/positioning-two.517ea432.svg";
export { SvgPositioningTwo as ReactComponent };